import React from 'react'
import Button from '../../../components/buttons/buttons.component'
import styled, { keyframes } from 'styled-components'
import AccordionSecondary from './../../../components/accordion/accordion-secondary.component'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import PaymentDataConfirmation from './payment-data-confirmation.component'
import PromotionDataConfirmation from './promotion-data-confirmation.component'
import OrderSummaryConfirmation from './order-summary-confirmation.component'
import CreditCardPurchaseSelectors from '../../../ducks/credit-card-purchase/credit-card-purchase.selectors'
import { connect } from 'react-redux'
import { history } from './../../../helpers/history'
import PromotionCouponService from '../../../services/promotion-coupon.service'
import { PAYMENT_METHODS } from '../../../constants'
import { toastActions } from '../../../actions'
import { downloadFromURL } from '../../../helpers/download.helper'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import { Creators as ClientTicketModalCreators } from '../../../ducks/client-ticket-modal/client-ticket-modal'
import FontAwesome from 'react-fontawesome'
import { ClientTicketService } from '../../../services/client-ticket.service'
import ClientTicketModalContainer from '../../private/client/my-purchases/components/client-ticket-modal-container.component'
import ModalConfirmation from '../../../components/modal/modal-confirmation.component'
import FileSaver from 'file-saver'
import PixInfo from '../../../components/pix/pix-info.component'
import { EmissionPollingGate } from './emission-polling-gate'

// Situacao do pedido exposta pelo endpoint "me/orders/{id}" da MuviHub -
// so estes tres rotulos existem (ClientOrderSituation no backend).
const ORDER_SITUATION = {
	COMPLETED: 'Concluído',
	CANCELLED: 'Cancelado',
}

const EMISSION_POLL_INTERVAL_MS = 5000

// Frases que se alternam com efeito de "digitando e apagando" enquanto o
// pedido de bilhetes de onibus e processado em segundo plano.
const EMISSION_TYPEWRITER_PHRASES = [
	'Verificando o pagamento',
	'Confirmando a reserva das poltronas',
	'Emitindo o(s) bilhete(s)',
	'Gerando o código de embarque',
	'Processando a emissão',
]
const EMISSION_TYPEWRITER_TYPE_SPEED_MS = 70
const EMISSION_TYPEWRITER_DELETE_SPEED_MS = 35
const EMISSION_TYPEWRITER_PAUSE_TYPED_MS = 1400
const EMISSION_TYPEWRITER_PAUSE_DELETED_MS = 300

class ConfirmationStepComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			message: '',
			isPromotionLoaded: false,
			emissionText: '',
			emissionTypewriterDone: false,
			emissionFailed: false,
		}

		this.emissionPollingGate = new EmissionPollingGate()
		this.emissionPollTimer = null
		this.emissionTypewriterTimer = null
		this.emissionTypewriterPhraseIndex = 0
		this.emissionTypewriterCharIndex = 0
		this.emissionTypewriterPhase = 'typing'

		this.getAccordionItems = getAccordionItems.bind(this)
		this.getPromotionCouponMessage = getPromotionCouponMessage.bind(this)
		this.promotionCouponControl = promotionCouponControl.bind(this)
		this.emissionPollingControl = emissionPollingControl.bind(this)
		this.startEmissionPolling = startEmissionPolling.bind(this)
		this.tickEmissionTypewriter = tickEmissionTypewriter.bind(this)
		this.stopEmissionPolling = stopEmissionPolling.bind(this)
		this.finishEmissionTypewriter = finishEmissionTypewriter.bind(this)
		this.checkEmissionStatus = checkEmissionStatus.bind(this)
		this.closeEmissionErrorModal = closeEmissionErrorModal.bind(this)
	}
	componentDidMount() {
		if (!this.props.isConfirmationStep) {
			this.setState({ isPromotionLoaded: false, message: '' })
		}
	}

	componentWillUnmount() {
		this.stopEmissionPolling()
	}

	downloadBpe = async () => {
		const {
			ticketsGoing,
			ticketsReturn,
			orderNumber,
			buyerId,
			user,
			showLoading,
			hideLoading,
			toastDanger,
		} = this.props
		const error = () => {
			toastDanger({
				message: 'Não foi possível fazer o download dos arquivos.',
			})
			hideLoading()
		}
		showLoading()
		ticketsGoing.map((f) => {
			ClientTicketService.download(
				orderNumber,
				f.trackNumber,
				buyerId || user.id,
				'Checkin de Embarque'
			)
				.then((response) => {
					const { data } = response
					if (data)
						FileSaver.saveAs(
							data,
							`Checkin de Embarque ${f.passengerName.toUpperCase()}.png`
						)
				})
				.catch(() => error())
				.finally(() => hideLoading())
			ClientTicketService.download(
				orderNumber,
				f.trackNumber,
				buyerId || user.id,
				'Passagem DaBPE'
			)
				.then((response) => {
					const { data } = response
					if (data)
						FileSaver.saveAs(
							data,
							`Passagem DaBPE ${f.passengerName.toUpperCase()}.pdf`
						)
				})
				.catch(() => error())
				.finally(() => hideLoading())
		})
		ticketsReturn.map((f) => {
			ClientTicketService.download(
				orderNumber,
				f.trackNumber,
				buyerId || user.id,
				'Checkin de Embarque'
			)
				.then((response) => {
					const { data } = response
					if (data)
						FileSaver.saveAs(
							data,
							`Checkin de Embarque ${f.passengerName.toUpperCase()}.png`
						)
				})
				.catch(() => error())
				.finally(() => hideLoading())
			ClientTicketService.download(
				orderNumber,
				f.trackNumber,
				buyerId || user.id,
				'Passagem DaBPE',
				`Passagem DaBPE ${f.passengerName.toUpperCase()}.pdf`
			)
				.then((response) => {
					const { data } = response
					if (data)
						FileSaver.saveAs(
							data,
							`Passagem DaBPE ${f.passengerName.toUpperCase()}.pdf`
						)
				})
				.catch(() => error())
				.finally(() => hideLoading())
		})
	}

	render() {
		const emv = this.props.pixData ? this.props.pixData.emv : ''
		const qrCodeBase64 = this.props.pixData
			? this.props.pixData.qrCodeBase64
			: ''
		const pixLink = this.props.pixData ? this.props.pixData.pixLink : ''
		const pixExpiration =
			this.props.pixData && this.props.pixData.pixExpiration
				? new Date(this.props.pixData.pixExpiration)
				: new Date()

		const notAuthenticated = this.props.user === null
		const bankSlipLink = this.props.bankSlipLink
		const orderNumber = this.props.orderNumber.toString()
		const showBpeDownloadLink = this.props.showBpeDownloadLink
		const isPendingEmission = this.props.isPendingEmission
		const renderBankSlipInfo =
			!isPendingEmission &&
			this.props.paymentMethod === PAYMENT_METHODS.BANKSLIP
		// Ao contrário do boleto/bpe, o Pix precisa continuar visível mesmo
		// com a emissão pendente: o QR Code é como o cliente paga, e o
		// polling de emissão roda por trás dele até o pagamento ser
		// identificado e o(s) bilhete(s) serem emitidos.
		const renderPixInfo = this.props.paymentMethod === PAYMENT_METHODS.PIX
		const renderBpeInfo =
			!isPendingEmission &&
			(this.props.paymentMethod === PAYMENT_METHODS.CREDIT_CARD ||
				this.props.paymentMethod === PAYMENT_METHODS.ONLINE_DEBT ||
				this.props.paymentMethod === PAYMENT_METHODS.MUVICARD)

		this.promotionCouponControl()
		this.emissionPollingControl()
		return (
			this.props.isConfirmationStep && (
				<React.Fragment>
					{!isPendingEmission && (
						<AccordionSecondary
							multiple
							noAnimated
							noClickable
							arrow={false}
							items={this.getAccordionItems()}
						/>
					)}
					<StyledDiv>
						<p style={{ marginBottom: '0' }}>
							<span className="f-x-large orange">
								Um e-mail de confirmação foi enviado para{' '}
								{this.props.buyerEmail || this.props.user.email}!
							</span>
						</p>

						{isPendingEmission && (
							<span className="f-x-large">
								<p className="f-x-large">
									{this.props.paymentMethod === PAYMENT_METHODS.PIX
										? 'Assim que identificarmos o pagamento via Pix, a emissão do(s) bilhete(s) será iniciada automaticamente.'
										: 'Seu pagamento foi aprovado! A emissão do(s) bilhete(s) pode levar alguns minutos.'}
								</p>
								<p className="f-x-large">
									Você receberá o(s) bilhete(s) por e-mail assim que a
									emissão for concluída, ou pode consultá-lo(s) a
									qualquer momento na opção{' '}
									<b>Minhas Compras</b>.
								</p>
								<p className="f-x-large">
									Se preferir, você pode aguardar aqui nesta tela: assim
									que a emissão for concluída, mostraremos automaticamente
									o(s) bilhete(s) para você.
								</p>
								{!this.state.emissionTypewriterDone && (
									<p className="f-x-large orange">
										<StyledTypewriter>
											{this.state.emissionText}
											<span className="cursor">|</span>
										</StyledTypewriter>
									</p>
								)}
							</span>
						)}

						{renderBankSlipInfo && (
							<span className="f-x-large">
								<p className="f-x-large">
									O pagamento do boleto pode levar até 3 dias úteis
									para constar em nosso sistema.
								</p>
								<p className="f-x-large">
									O Não Pagamento ou Pagamentos realizados após o
									vencimento implica no cancelamento automático das
									reservas.
								</p>
								<p className="f-x-large">
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											margin: '4rem auto',
										}}>
										<Button
											primary
											onClick={() => {
												const { showLoading, hideLoading } =
													this.props
												showLoading()

												const downloadPromise = downloadFromURL(
													bankSlipLink,
													`boleto-moveflex-pedido-${orderNumber}.pdf`
												)

												downloadPromise
													.then(() => hideLoading())
													.catch(() => hideLoading())
											}}>
											Imprimir boleto
										</Button>
									</div>
								</p>
							</span>
						)}

						{renderPixInfo && (
							<span className="f-x-large">
								<p className="f-x-large">
									O não pagamento implica no cancelamento automático da
									reserva de passagem.
								</p>
								<PixInfo
									pixImageQrCode={qrCodeBase64}
									pixValidity={pixExpiration}
									pixEmv={emv}
								/>
							</span>
						)}

						{renderBpeInfo &&
							(showBpeDownloadLink ? (
								<span className="f-x-large">
									<br />
									<p className="f-x-large">
										O seu bilhete de passagem foi enviado via e-mail
										ou você pode salvar clicando no botão azul abaixo
										nesta página!
									</p>
									<p className="f-x-large">
										É obrigatório a apresentação do mesmo para
										embarque. A rodoviária não realiza impressão de
										segunda via de bilhete de passagem.
									</p>
									<p>
										<Button
											secondary
											type="button"
											onClick={this.downloadBpe}>
											<span style={{ marginRight: 5 }}>
												<FontAwesome name="qrcode" size="lg" />
											</span>
											<span style={{ marginRight: 5 }}>
												<FontAwesome name="download" size="lg" />
											</span>
											Salvar Passagem(ns) Digital(is)
										</Button>
									</p>
								</span>
							) : (
								<span className="f-x-large">
									<br />
									<p className="f-x-large">
										<b>Para viagens DENTRO DO RS</b>, você receberá
										sua passagem digital e cartão de embarque para
										apresentá-los de forma digital ou impressa
										diretamente no embarque!
									</p>
									<p className="f-x-large">
										<b>Para viagens ENTRE ESTADOS</b>, este documento
										deverá ser apresentado na estação rodoviária de
										embarque ou no guichê da empresa para emissão de
										seu(s) bilhete(s) eletrônico(s).
									</p>
									<p className="f-x-large">
										Também é possível visualizar seu voucher no painel
										do cliente, no menu “Minhas compras”
									</p>
								</span>
							))}

						{notAuthenticated ||
						renderBankSlipInfo ||
						renderPixInfo ? null : (
							<div className="button-container">
								<Button
									primary
									type="button"
									onClick={() =>
										history.push('/cliente/minhas-compras')
									}>
									Minhas passagens
								</Button>
							</div>
						)}
					</StyledDiv>
					{isPendingEmission && (
						<React.Fragment>
							<ClientTicketModalContainer handleCancelTicket={() => {}} />
							<ModalConfirmation
								isOpen={this.state.emissionFailed}
								onResult={this.closeEmissionErrorModal}
								OnlyNoButton
								buttonNoText="Fechar"
								title="Não foi possível confirmar a emissão">
								<p>
									Parece que algo deu errado e seu bilhete de passagem
									não foi gerado.
								</p>
								<p>Não se preocupe, a compra não será cobrada.</p>
								<p>Efetue uma nova tentativa de compra!</p>
							</ModalConfirmation>
						</React.Fragment>
					)}
				</React.Fragment>
			)
		)
	}
}

const StyledDiv = styled.div`
	margin-bottom: 6rem;
	margin-top: 3rem;
	text-align: center;

	.button-container {
		margin-top: 1.5rem;
	}
`

const blink = keyframes`
	0%, 49% {
		opacity: 1;
	}
	50%, 100% {
		opacity: 0;
	}
`

const StyledTypewriter = styled.span`
	.cursor {
		animation: ${blink} 1s step-start infinite;
	}
`

function getAccordionItems() {
	const { installmentsQtt } = this.props
	const orderNumber = this.props.orderNumber.toString()
	const orderNumberLength = 6
	const formattedOrderNumber =
		orderNumber.length > orderNumberLength
			? orderNumber
			: ('0'.repeat(orderNumberLength) + orderNumber).slice(
					-orderNumberLength
			  )

	var accordionArray = [
		{
			title: `Resumo do pedido ${formattedOrderNumber}`,
			initiallyOpened: true,
			content: <OrderSummaryConfirmation />,
		},
	]

	if (installmentsQtt > 0)
		accordionArray.push({
			title: 'Dados do pagamento',
			initiallyOpened: true,
			content: <PaymentDataConfirmation />,
		})

	accordionArray.push({
		title: this.state.message != '' ? 'Promoção' : '',
		initiallyOpened: true,
		content: <PromotionDataConfirmation message={this.state.message} />,
	})
	return accordionArray
}

function getPromotionCouponMessage() {
	const orderNumber = this.props.orderNumber
	const paymentMethod = this.props.paymentMethod

	if (orderNumber > 0 && paymentMethod !== PAYMENT_METHODS.BANKSLIP) {
		PromotionCouponService.getUberCouponByOrderNumber(orderNumber).then(
			({ data }) => {
				data
					? this.setState({ message: data.notes, isPromotionLoaded: true })
					: this.setState({ message: '', isPromotionLoaded: true })
			}
		)
	} else {
		this.setState({ message: '', isPromotionLoaded: true })
	}
}

function promotionCouponControl() {
	if (!this.props.isConfirmationStep) {
		if (this.state.message != '') {
			this.setState({ message: '', isPromotionLoaded: false })
		}
		if (this.state.isPromotionLoaded) {
			this.setState({ isPromotionLoaded: false })
		}
	}

	if (this.props.isConfirmationStep && !this.state.isPromotionLoaded) {
		this.getPromotionCouponMessage()
	}
}

// A emissao dos bilhetes (cartao/Muvicard no checkout novo) e assincrona -
// consulta o pedido na MuviHub a cada 5s ate ele sair de "Em processamento",
// entao abre o mesmo modal de detalhes usado em "Minhas Compras".
function emissionPollingControl() {
	const { isConfirmationStep, isPendingEmission, orderId, user } = this.props

	// Compra sem login (guest) nao tem token para consultar "me/orders" na
	// MuviHub - a propria tela ja esconde o acesso a "Minhas Compras" nesse caso.
	if (!isConfirmationStep || !isPendingEmission || !orderId || !user) return

	if (this.emissionPollingGate.shouldStart(orderId)) {
		this.startEmissionPolling()
	}
}

function startEmissionPolling() {
	this.tickEmissionTypewriter()

	this.checkEmissionStatus()
	this.emissionPollTimer = setInterval(
		this.checkEmissionStatus,
		EMISSION_POLL_INTERVAL_MS
	)
}

// Efeito de maquina de escrever: digita uma frase, pausa, apaga, pausa e
// passa pra proxima - em loop entre EMISSION_TYPEWRITER_PHRASES.
function tickEmissionTypewriter() {
	let delay = EMISSION_TYPEWRITER_TYPE_SPEED_MS

	switch (this.emissionTypewriterPhase) {
		case 'typing': {
			const phrase =
				EMISSION_TYPEWRITER_PHRASES[this.emissionTypewriterPhraseIndex]
			this.emissionTypewriterCharIndex += 1

			if (this.emissionTypewriterCharIndex >= phrase.length) {
				this.emissionTypewriterPhase = 'paused-typed'
				delay = EMISSION_TYPEWRITER_PAUSE_TYPED_MS
			}
			break
		}
		case 'paused-typed':
			this.emissionTypewriterPhase = 'deleting'
			delay = EMISSION_TYPEWRITER_DELETE_SPEED_MS
			break
		case 'deleting':
			this.emissionTypewriterCharIndex -= 1

			if (this.emissionTypewriterCharIndex <= 0) {
				this.emissionTypewriterPhase = 'paused-deleted'
				delay = EMISSION_TYPEWRITER_PAUSE_DELETED_MS
			}
			break
		case 'paused-deleted':
		default:
			this.emissionTypewriterPhraseIndex =
				(this.emissionTypewriterPhraseIndex + 1) %
				EMISSION_TYPEWRITER_PHRASES.length
			this.emissionTypewriterCharIndex = 0
			this.emissionTypewriterPhase = 'typing'
			break
	}

	const currentPhrase =
		EMISSION_TYPEWRITER_PHRASES[this.emissionTypewriterPhraseIndex]

	this.setState({
		emissionText: currentPhrase.slice(0, this.emissionTypewriterCharIndex),
	})

	this.emissionTypewriterTimer = setTimeout(this.tickEmissionTypewriter, delay)
}

function stopEmissionPolling() {
	clearInterval(this.emissionPollTimer)
	clearTimeout(this.emissionTypewriterTimer)
	this.emissionPollTimer = null
	this.emissionTypewriterTimer = null
}

// Chamado quando a consulta de status termina (sucesso ou erro): para o
// polling e deixa a palavra que estava sendo digitada terminar de ser
// apagada, em vez de sumir congelada pela metade.
function finishEmissionTypewriter() {
	clearInterval(this.emissionPollTimer)
	this.emissionPollTimer = null
	clearTimeout(this.emissionTypewriterTimer)

	const eraseStep = () => {
		if (this.emissionTypewriterCharIndex <= 0) {
			this.emissionTypewriterTimer = null
			this.setState({ emissionText: '', emissionTypewriterDone: true })
			return
		}

		this.emissionTypewriterCharIndex -= 1
		const currentPhrase =
			EMISSION_TYPEWRITER_PHRASES[this.emissionTypewriterPhraseIndex]

		this.setState({
			emissionText: currentPhrase.slice(0, this.emissionTypewriterCharIndex),
		})

		this.emissionTypewriterTimer = setTimeout(
			eraseStep,
			EMISSION_TYPEWRITER_DELETE_SPEED_MS
		)
	}

	eraseStep()
}

function checkEmissionStatus() {
	const {
		orderId,
		orderNumber,
		fetchOrderForModal,
		openClientTicketModal,
	} = this.props

	ClientTicketService.getOrder(orderId, { orderNumber })
		.then((order) => {
			const isFinished =
				order.status === ORDER_SITUATION.COMPLETED ||
				order.status === ORDER_SITUATION.CANCELLED

			if (!isFinished) return

			this.finishEmissionTypewriter()
			fetchOrderForModal(orderId, orderNumber).then(openClientTicketModal)
		})
		.catch(() => {
			this.finishEmissionTypewriter()
			this.setState({ emissionFailed: true })
		})
}

function closeEmissionErrorModal() {
	this.setState({ emissionFailed: false })
}

const mapStateToProps = (store) => ({
	user: store.user,
	buyerId: store.ticketSale.buyerId,
	buyerEmail: store.ticketSale.buyerEmail,
	orderNumber: store.ticketSale.orderNumber,
	paymentMethod: store.ticketSale.paymentMethod,
	showBpeDownloadLink: store.ticketSale.showBpeDownloadLink,
	isPendingEmission: store.ticketSale.isPendingEmission,
	orderId: store.ticketSale.orderId,
	installmentsQtt: CreditCardPurchaseSelectors.getInstallmentsQtt(
		store.creditCardPurchase
	),
	isConfirmationStep: TicketSaleSelectors.isConfirmationStep(store),
	lastFourNumbers: CreditCardPurchaseSelectors.getCardLastFourNumbers(
		store.creditCardPurchase
	),
	bankSlipLink: store.ticketSale.bankSlipLink,
	pixData: store.ticketSale.pixData,
	ticketsGoing: store.ticketSale.confirmedTicketsGoing,
	ticketsReturn: store.ticketSale.confirmedTicketsReturn,
	anticipatedPix: store.ticketSale.anticipatedPix,
})

const mapDispatchToProps = {
	showLoading: SiteCreators.showLoading,
	hideLoading: SiteCreators.hideLoading,
	toastDanger: toastActions.danger,
	fetchOrderForModal: ClientTicketModalCreators.fetchData,
	openClientTicketModal: ClientTicketModalCreators.openModal,
}

const ConfirmationStep = connect(
	mapStateToProps,
	mapDispatchToProps
)(ConfirmationStepComponent)

export default ConfirmationStep
